/**
 * Utilitário para decodificar mensagens protobuf da MEXC
 * Usando a biblioteca protobuf.js
 * Documentação: https://github.com/protobufjs/protobuf.js/
 */

/* eslint-disable */

// Schema protobuf para MEXC - estrutura completa do websocket
const protoSchema = `
syntax = "proto3";

option java_package = "com.mxc.push.common.protobuf";
option optimize_for = SPEED;
option java_multiple_files = true;
option java_outer_classname = "PushDataV3ApiWrapperProto";

message PublicAggreDealsV3Api {
  repeated PublicAggreDealsV3ApiItem deals = 1;
  string eventType = 2;
}

message PublicAggreDealsV3ApiItem {
  string price = 1;
  string quantity = 2;
  int32 tradeType = 3;
  int64 time = 4;
}

message PublicSpotKlineV3Api {
  string interval = 1;
  int64 windowStart = 2;
  string openingPrice = 3;
  string closingPrice = 4;
  string highestPrice = 5;
  string lowestPrice = 6;
  string volume = 7;
  string amount = 8;
  int64 windowEnd = 9;
}

message PushDataV3ApiWrapper {
  string channel = 1;
  oneof body {
    PublicSpotKlineV3Api publicSpotKline = 308;
  }
  optional string symbol = 3;
  optional string symbolId = 4;
  optional int64 createTime = 5;
}
`

// Variáveis globais para protobuf
let protobuf = null
let PushDataV3ApiWrapper = null

/**
 * Inicializa a biblioteca protobuf.js
 */
const initializeProtobuf = async () => {
  try {
    // Carregar protobuf.js via CDN
    const response = await fetch('https://cdnjs.cloudflare.com/ajax/libs/protobufjs/7.5.3/protobuf.js')
    const code = await response.text()
    
    // Criar contexto isolado para executar o código
    const exports = {}
    const module = { exports }
    
    // Executar o código do protobuf.js
    new Function('module', 'exports', code)(module, exports)
    protobuf = module.exports
    
    // Parsear o schema e obter o tipo
    PushDataV3ApiWrapper = protobuf.parse(protoSchema).root.lookupType("PushDataV3ApiWrapper")
    
    
    return true
  } catch (error) {
    console.error('❌ Erro ao carregar protobuf.js:', error.message)
    return false
  }
}

/**
 * Decodifica especificamente deals agregados
 */
export const decodeAggreDeals = (buffer) => {
  try {
    if (!PushDataV3ApiWrapper) {
      console.warn('⚠️ Protobuf não inicializado')
      return null
    }

    // Converter para Uint8Array se necessário
    let uint8Data = buffer
    if (buffer instanceof ArrayBuffer) {
      uint8Data = new Uint8Array(buffer)
    } else if (buffer instanceof Buffer) {
      uint8Data = new Uint8Array(buffer)
    }

    if (!uint8Data || uint8Data.length === 0) {
      console.warn('⚠️ Buffer vazio ou inválido')
      return null
    }

    // Decodificar usando protobuf.js
    const message = PushDataV3ApiWrapper.decode(uint8Data)
    
    // Converter para objeto JavaScript
    const data = PushDataV3ApiWrapper.toObject(message, {
      longs: String,
      enums: String,
      bytes: String,
      defaults: true,
      arrays: true,
      objects: true
    })
    
    // Extrair deals se disponível
    if (data.publicAggreDeals && data.publicAggreDeals.deals) {
      return {
        symbol: data.symbol,
        channel: data.channel,
        deals: data.publicAggreDeals.deals,
        eventType: data.publicAggreDeals.eventType,
        sendTime: data.sendTime,
        createTime: data.createTime
      }
    }
    
    return null
  } catch (error) {
    console.error('❌ Erro ao decodificar deals:', error.message)
    return null
  }
}

/**
 * Decodifica especificamente kline data
 */
export const decodeKline = (buffer) => {
  try {
    if (!PushDataV3ApiWrapper) {
      console.warn('⚠️ Protobuf não inicializado')
      return null
    }

    // Converter para Uint8Array se necessário
    let uint8Data = buffer
    if (buffer instanceof ArrayBuffer) {
      uint8Data = new Uint8Array(buffer)
    } else if (buffer instanceof Buffer) {
      uint8Data = new Uint8Array(buffer)
    }

    if (!uint8Data || uint8Data.length === 0) {
      console.warn('⚠️ Buffer vazio ou inválido')
      return null
    }

    // Decodificar usando protobuf.js
    const message = PushDataV3ApiWrapper.decode(uint8Data)
    
    // Converter para objeto JavaScript
    const data = PushDataV3ApiWrapper.toObject(message, {
      longs: String,
      enums: String,
      bytes: String,
      defaults: true,
      arrays: true,
      objects: true
    })
    
    // Extrair kline se disponível
    if (data.publicSpotKline) {
      return {
        symbol: data.symbol,
        channel: data.channel,
        kline: data.publicSpotKline,
        createTime: data.createTime
      }
    }
    
    return null
  } catch (error) {
    console.error('❌ Erro ao decodificar kline:', error.message)
    return null
  }
}

// Inicialização automática
let initPromise = null

export const ensureProtobufInitialized = () => {
  if (!initPromise) {
    initPromise = initializeProtobuf()
  }
  return initPromise
}

// Inicializar automaticamente
setTimeout(async () => {
  await ensureProtobufInitialized()
}, 100)